import {
  SET_STUDY_PROGRESS,
  ADD_STUDY_INFO,
  SET_TOTAL_SAMPLES_NEEDED,
  SET_STUDY_SAVE_PATH,
  RECEIVE_SET_STUDY,
  REQUEST_SAVE_STUDY,
  RECEIVE_SAVE_STUDY,
  RESET_REDUX,
  TOGGLE_LOCK,
  SET_DATA_LOCAL,
  RESET_SAVE_STUDY,
  SET_ENCRYPTION,
  SET_STUDY_NOTE,
  SET_SERVER_VERSION,
} from "../actions/index";

import produce from "immer";

const initialState = {
  id: null,
  protocolId: null,
  participantId: null,
  protocolName: "",
  skinType: "",
  gender: "",
  birthYear: "",
  otherId: "",
  progress: 0,
  totalSamplesNeeded: null,
  version: "2.4",
  serverVersion: null,
  locked: false,
  allDataLocal: true,
  requestSave: false,
  studySaved: false,
  encryption: true,
  studySavePath: "~/Desktop/MicroElastic/",
  studyHash: [],
  notes: null,
  wipPath: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case RECEIVE_SET_STUDY: {
        draft.id = action.studyInfo.id;
        draft.protocolId = action.studyInfo.protocolId;
        draft.participantId = action.studyInfo.participantId;
        draft.protocolName = action.studyInfo.protocolName;
        draft.skinType = action.studyInfo.skinType;
        draft.gender = action.studyInfo.gender;
        draft.otherId = action.studyInfo.otherId;
        draft.birthYear = action.studyInfo.birthYear;
        draft.startedAt = action.studyInfo.startedAt;
        draft.studyDate = action.studyInfo.studyDate;
        draft.progress = action.studyInfo.progress;
        draft.locked = action.studyInfo.locked;
        draft.encryption = action.studyInfo.encryption;
        draft.notes = action.studyInfo.notes;
        draft.studyHash = action.studyInfo.studyHash;
        draft.studySaved = action.studyInfo.studySaved;
        draft.studySavePath = action.path;
        draft.totalSamplesNeeded = action.studyInfo.totalSamplesNeeded;

        break;
      }

      case ADD_STUDY_INFO: {
        draft.id = action.id;
        draft.protocolId = action.protocolId;
        draft.participantId = action.participantId;
        draft.protocolName = action.protocolName;
        draft.startedAt = action.startedAt;
        draft.studyDate = action.studyDate;
        draft.skinType = action.skinType;
        draft.gender = action.gender;
        draft.birthYear = action.birthYear;
        draft.otherId = action.otherId;
        break;
      }

      case SET_STUDY_PROGRESS: {
        draft.progress = action.newProgress;
        break;
      }

      case SET_STUDY_NOTE: {
        draft.notes = action.text;
        break;
      }

      case SET_TOTAL_SAMPLES_NEEDED: {
        draft.totalSamplesNeeded = action.totalSamplesNeeded;
        break;
      }

      case SET_STUDY_SAVE_PATH: {
        draft.studySavePath = action.studySavePath.replace(/[\\]/g, "/");
        draft.wipPath = action.wipPath;
        break;
      }

      case TOGGLE_LOCK: {
        draft.locked = !draft.locked;
        break;
      }

      case SET_DATA_LOCAL: {
        draft.allDataLocal = action.allDataLocal;
        break;
      }

      case REQUEST_SAVE_STUDY: {
        draft.requestSave = true;
        break;
      }

      case RECEIVE_SAVE_STUDY: {
        draft.requestSave = false;
        draft.studySaved = true;
        break;
      }

      case RESET_SAVE_STUDY: {
        draft.requestSave = false;
        break;
      }

      case SET_ENCRYPTION: {
        draft.encryption = action.encryption;
        break;
      }

      case SET_SERVER_VERSION: {
        draft.serverVersion = action.serverVersion;
        break;
      }

      case RESET_REDUX:
        return initialState;

      default:
        return draft;
    }
  });
